/**
 * CheckInFooter Component
 * Sticky footer with Submit button
 */

import React from 'react';
import { View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { Button } from '@/components/ui/button';

export interface CheckInFooterProps {
  /** Callback when submit button is pressed */
  onSubmit: () => void;
  /** Whether the submit button is enabled */
  isEnabled?: boolean;
  /** Whether submission is in progress */
  isSubmitting?: boolean;
  /** Text to display on the button (overrides automatic text from entryCount) */
  submitText?: string;
  /** Number of submittable entries (drives dynamic button text) */
  entryCount?: number;
}

export function CheckInFooter({
  onSubmit,
  isEnabled = false,
  isSubmitting = false,
  submitText,
  entryCount = 1,
}: CheckInFooterProps) {
  const insets = useSafeAreaInsets();

  const buttonText =
    submitText ??
    (entryCount <= 1
      ? 'Submit Check-in'
      : `Submit ${entryCount} Check-ins`);

  return (
    <View
      className="px-4 pt-3 border-t bg-background border-border"
      style={{ paddingBottom: Math.max(insets.bottom, 16) }}
    >
      <Button
        onPress={onSubmit}
        disabled={!isEnabled || isSubmitting}
        loading={isSubmitting}
        variant="primary"
        fullWidth
        accessibilityLabel={buttonText}
      >
        {buttonText}
      </Button>
    </View>
  );
}

export default CheckInFooter;
